export default [
  {
    path: '',
    name: 'product unit list',
    component: () => import('@/views/app/product-unit/list/page-list.vue'),
    meta: { title: 'Daftar No Serial' },
  },
  {
    path: 'import',
    name: 'product unit import',
    component: () => import('@/views/app/product-unit/create/page-create.vue'),
    meta: { title: 'Import No Serial' },
  },
]
